import { VideoInline } from '../../../components/blocks/VideoInline';
import { VideoInlineProps } from '../../../components/blocks/VideoInline';

export const mapVideoInline = ({ video_source, video_caption }: VideoInline): VideoInlineProps => {
  return {
    videoSrc: video_source,
    videoCaption: video_caption,
  };
};
